import { Group } from '$synapse/models';
import { GroupService } from '$synapse/services';
import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-group-update-modal',
  templateUrl: './group-update-modal.component.html',
  imports: [SHARED_IMPORTS],
})
export class GroupUpdateModalComponent {
  private readonly _data = inject<Group>(MAT_DIALOG_DATA);
  private readonly _groupService = inject(GroupService);
  private readonly _modalDisplay =
    inject<MatDialogRef<GroupUpdateModalComponent>>(MatDialogRef);

  readonly group: Group = new Group(this._data);
  sending = false;

  submit(): void {
    this.sending = true;
    this._updateGroup().subscribe((group: Group) => {
      this._modalDisplay.close(group);
    });
  }

  private _updateGroup(): Observable<Group> {
    return this._groupService.update(this.group);
  }
}
